<script>
    import { onMount } from "svelte";

    export let label;
    export let options = [];
    export let selectedOptions = [];
    export let id;

    let showOptions = false;

    function toggleOptions() {
        showOptions = !showOptions;
    }

    function handleOptionClick(option) {
        const index = selectedOptions.findIndex(opt => opt === option);
        if (index === -1) {
            selectedOptions = [...selectedOptions, option];
        } else {
            selectedOptions = selectedOptions.filter((_, idx) => idx !== index);
        }
    }

    function handleClickOutside(event) {
        if (showOptions && !event.target.closest(`#dropdown`)) {
            showOptions = false;
        }
    }

    onMount(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    });
</script>

<div class="w-full px-3 mb-6 md:mb-0">
    <label class="block uppercase tracking-wide text-secondary-text text-xs font-bold mb-1" for={id}>
        {label}
    </label>

    <div id="dropdown" class="relative">
        <button class="w-full bg-accent-light text-secondary-text rounded py-3 px-4 flex items-center justify-between cursor-pointer focus:ring-2 focus:ring-accent-border focus:outline-none focus:border-none" on:click={toggleOptions}>
            <span><i class="fas fa-plus mr-2"></i> Optionen auswählen...</span>
        </button>

        {#if showOptions}
            <div class="absolute z-10 mt-1 bg-white rounded w-full shadow-md">
                {#each options as option}
                    <label class="flex items-center px-4 py-2 cursor-pointer hover:bg-accent-hover">
                        <input type="checkbox" class="mr-2 text-accent-dark focus:ring-accent-dark" checked={selectedOptions.filter(e => e === option).length > 0} on:click={() => handleOptionClick(option)}/>
                        <span>{option}</span>
                    </label>
                {/each}
            </div>
        {/if}
    </div>
</div>
